import React from "react";
import {AdminSidebar, DoctorSidebar} from "./SIdebar.Types";
import { getAuthority } from "../../axios/authorityManager";

const SideBar = () => {
  return (
    <>
      {getAuthority() === "ADMIN" && <AdminSidebar />}
      {getAuthority() === "DOCTOR" && <DoctorSidebar />}
    </>
  );
};

SideBar.propTypes = {};
export default SideBar;
